import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import VirtualAccountSetupsPicker from './VirtualAccountSetupsPicker';

const styles = () => ({
  root: {},
});

const WhatIfFacetPlanUpdateVirtualAccountsTemplate = ({
  resource,
}) => {
  return (
    <VirtualAccountSetupsPicker resource={resource} />
  );
};

WhatIfFacetPlanUpdateVirtualAccountsTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(WhatIfFacetPlanUpdateVirtualAccountsTemplate);
